/* tslint:disable:indent */
export class WhmcsClient {

	public id: number;
	public firstname: string;
	public lastname: string;
	public companyname: string;
	public email: string;
	public active: boolean;

	constructor(id: number, firstname: string, lastname: string, companyname: string, email: string, active: boolean) {
		this.id = id;
		this.firstname = firstname;
		this.lastname = lastname;
		this.companyname = companyname;
		this.email = email;
		this.active = active;
	}

}

export class WhmcsClientDetails {
	public phonecc: string;
	public phonenumber: string;
	public telephoneNumber: string;
	public tax_id: string;
	public notes: string;
	public country: string;

	constructor(phonecc: string, phonenumber: string, telephoneNumber: string, tax_id: string, notes: string, country: string) {
		this.phonecc = phonecc;
		this.phonenumber = phonenumber;
		this.telephoneNumber = telephoneNumber;
		this.tax_id = tax_id;
		this.notes = notes;
		this.country = country;
	}
}




